// Difficulty tier 3 (hard). See easy_templates.js for the format/derivation
// notes — geometry is auto-derived and sections chain via a height offset, so
// there is no startsHigh/endsHigh metadata.
export const hardTemplates = {
  spikes3: {
    layout: `
....SSSS.....SSSS.....SSSS....
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  pits3: {
    layout: `
BBBB......BBB.....BBB......BBB
BBBB......BBB.....BBB......BBB
`,
    metadata: {},
  },
  raised_platform3: {
    layout: `
............S.......S.........
.........BBBB....BBBB.........
..............................
..............................
BBBB......................BBBB
BBBB......................BBBB
`,
    metadata: {},
  },

  jumping3: {
    layout: `
......BBB.....BB.....BBB......
..............................
..SSSSSSSSSSSSSSSSSSSSSSSSSS..
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  lasers3: {
    layout: `
....L.........L.........L.....
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  projectile_stair_up3: {
    layout: `
......................BBB..BBB
...........................BBB
..BB.............BBB.......BBB
..BB.......................pBB
............BBB............BBB
...........................BBB
.......BBB.................BBB
...........................BBB
BBBBB......................BBB
BBBBB......................BBB
`,
    metadata: {},
  },

  stair_up3: {
    layout: `
.......................BB...BB
..............................
..................BB..........
..............................
.............BB...............
..............................
........BB....................
..............................
BBBBB.........................
BBBBB.........................
`,
    metadata: {},
  },

  stair_down3: {
    layout: `
.....S........................
BB...BBB......................
..............................
..........BBB.................
...............S..............
...............BBB............
..............................
....................BBB.......
.........................S....
.........................BBBBB
.........................BBBBB
`,
    metadata: {},
  },
  projectile_stair_down3: {
    layout: `
BBB..BBB...................BB.
BBB........................pB.
BBB.......BBB..............BB.
BBB........................BB.
BBB............BBB............
BBB...........................
BBB.................BBB.......
BBB...........................
BBB......................BBBBB
BBB......................BBBBB
`,
    metadata: {},
  },
  // Three-lane projectile crossfire over spikes (left blocks are the backstop
  // that contains the rounds). The floor is thin; the skirt fills it when raised.
  projectiles3: {
    layout: `
..BB......................pB..
..BB......................pB..
..BB......................pB..
..BB...........SS.........BB..
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Recessed crossings with stepping platforms (see sunk_platform1).
  spike_sunk_platform3: {
    layout: `
.....SS.......................
BBBBBBB.................BBBBBB
BBBBBBB.................BBBBBB
BBBBBBB..BBB.......BBB..BBBBBB
BBBBBBB.................BBBBBB
`,
    metadata: {},
  },
  projectile_sunk_platform3: {
    layout: `
BBBBBBB.................BBBBBB
BBBBBBB.................pBBBBB
BBBBBBB..BBB.......BBB..BBBBBB
BBBBBBB.................BBBBBB
`,
    metadata: {},
  },

  // A solid-floored laser maze (see raised_lasers2).
  raised_lasers3: {
    layout: `
...........LL........LL.......
BBB...BBBBBBBBBBBBBBBBBB...BBB
BBB...BBBBBBBBBBBBBBBBBB...BBB
BBB...BBBBBBBBBBBBBBB......BBB
BBB...BBBBBBBBBBBBBBB......BBB
BBB...BBBBBBBBBBBBBBB...BBBBBB
BBB...BBBBBBBBBBBB......BBBBBB
BBB...BBBBBBBBBBBB......BBBBBB
BBB...BBBBBBBBBBBB...BBBBBBBBB
BBB.............L....BBBBBBBBB
BBB.............L....BBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Solid step ramps (+3 / -3) with spikes to time on the approach and the
  // landing — the mid-size height changes hard was missing.
  step_up3: {
    layout: `
....................S.........
.................BBBBBBBBBBBBB
.................BBBBBBBBBBBBB
.........S.......BBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  step_down3: {
    layout: `
.........S....................
BBBBBBBBBBBBB.................
BBBBBBBBBBBBB.................
BBBBBBBBBBBBB.......S.........
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Platform climb (+6) with a spike on the stepping stone — land clean.
  raised_platform_up3: {
    layout: `
.......................BBBBBBB
.......................BBBBBBB
............S..........BBBBBBB
.........BBBBBBBBBB....BBBBBBB
.......................BBBBBBB
.......................BBBBBBB
BBBBB..................BBBBBBB
BBBBB..................BBBBBBB
`,
    metadata: {},
  },

  // Projectile gauntlets that change plane — turret + a spike on the step.
  projectile_up3: {
    layout: `
........................S.....
......................BBBBBBBB
..BB..........BB......BBBBBBBB
..BB..........pB......BBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
  projectile_down3: {
    layout: `
....S.........................
BBBBBBBB......................
BBBBBBBB..............BB......
BBBBBBBB..............pB......
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },

  // Wall-slide DESCENT (-7): run off the high ledge into the shaft and ride the
  // wall down — the slow wall-slide grip (terminal -0.1 vs the -0.3 free fall)
  // lets you control the drop, time the vertical laser beam strung down one
  // column of the shaft (lasers fire vertically, so you grip the wall and pass
  // its cell while it's off), then slip out the doorway at the bottom to the low
  // exit. The opposite of the climbs: this is the "control descent between two
  // walls" use of the move. contentTopRow is pinned to the entry height (the
  // walls run above it as the sliding surface) so it stays eligible while H is
  // high — see easy_templates.js.
  wall_descent3: {
    layout: `
..............BBB.............
..............BBB.............
..............BBB.............
..............BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB..L.BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....BBB.............
BBBBBBBBBB....................
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 9 },
  },

  // wall_climb_laser3 (+8): a climbing shaft with a vertical laser beam strung
  // down one cell of the gap — grip the wall below it and launch through its
  // column on the off-pulse. Spike on the exit ledge. See easy_templates.js.
  wall_climb_laser3: {
    layout: `
.............BBBB.............
.............BBBB.............
.............BBBB.............
.............BBBB.........S...
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB.L..BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.....................BBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 9 },
  },

  // wall_climb_high3 (+10): a tall ascent — the biggest single climb, several
  // wall-jumps up to a high plateau, with a spike on the landing. See
  // easy_templates.js.
  wall_climb_high3: {
    layout: `
.............BBBB.............
.............BBBB.............
.............BBBB.........S...
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.............BBBB....BBBBBBBBB
.....................BBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: { contentTopRow: 11 },
  },
};
